module.exports = __webpack_public_path__ + "static/media/SS.79597ae9.svg";